module.exports = __webpack_public_path__ + "img/bsn_2.0a8f2eaa.png";